import { Component, OnInit } from '@angular/core';
import { GamesService } from '../Services/games.service';
@Component({
  selector: 'app-addgame',
  templateUrl: './addgame.component.html',
  styleUrls: ['./addgame.component.css']
})
export class AddgameComponent implements OnInit {
  thumb:File;
  thumb1:File;
  thumb2:File;
  poster:File;
  game_file:string;
  game_name:string;
  game_name_ar:string;
  game_name_pr:string;
  game_desc:string;
  game_desc_ar:string;
  game_desc_pr:string;
  user_id:string;
  game_cat:string;
  game_type:string;
  game_countries:string;
  game_age:string;
  package_name:string;
  game_dev:string;
  game_tags:string;
  show_package:boolean;
  cats=[];
  icon:string='fa fa-cloud-upload';
  has_leader:boolean;
  constructor(private games:GamesService) {

    this.user_id=localStorage.getItem('user_id');


  }
  type(){
    if(this.game_type=='andriod'){
      this.show_package=true;
    }
    else{
      this.show_package=false;
    }
  }

  ngOnInit() {
    this.getAllCats();
  }
  /**
   * @description get all games cats
   */
  getAllCats(){
    this.games.getAllCats().subscribe(next=>{
      this.cats=next['cat_lists'];
      console.log(next['cat_lists']);
    },error=>{console.log(error)});
  }

  //get the game thumb
  getThumb(inputfile){
    if(inputfile.target.files&&inputfile.target.files[0]){
      this.thumb=inputfile.target.files[0];


      // var _URL = window.URL;
      // var img = new Image( );
      //  var imgwidth = 0;
      //  var imgheight = 0;
      //  var maxwidth = 640;
      //  var maxheight = 640;
      //  img.src = _URL.createObjectURL(this.thumb.webkitRelativePath);
      //  imgwidth = img.width;
      //  imgheight = img.height;
      //  img.onload = function() {


      //  }
      //  //console
      //  if(imgwidth<1900){
      //    console.log('width ecess',img.width);
      //  }
      //  else {
      //    console.log('higigigi');
      //  }
      console.log(this.thumb);
    }
  }

  getThumb1(inputfile){
    if(inputfile.target.files&&inputfile.target.files[0]){
      this.thumb1=inputfile.target.files[0];
      console.log(this.thumb1);
    }
  }
  getThumb2(inputfile){
    if(inputfile.target.files&&inputfile.target.files[0]){
      this.thumb2=inputfile.target.files[0];
      console.log(this.thumb2);
    }
  }


  getPoster(inputfile){

    if(inputfile.target.files&&inputfile.target.files[0]){
      this.poster=inputfile.target.files[0];


      // var _URL = window.URL;
      // var img = new Image( );
      //  var imgwidth = 0;
      //  var imgheight = 0;
      //  var maxwidth = 640;
      //  var maxheight = 640;
      //  img.src = _URL.createObjectURL(this.thumb.webkitRelativePath);
      //  imgwidth = img.width;
      //  imgheight = img.height;
      //  img.onload = function() {


      //  }
      //  //console
      //  if(imgwidth<1900){
      //    console.log('width ecess',img.width);
      //  }
      //  else {
      //    console.log('higigigi');
      //  }

















      console.log(this.poster);
    }
  }



  //get the game file
  getGame(inputfile){

    if(inputfile.target.files&&inputfile.target.files[0]){
      this.game_file=inputfile.target.files[0];
      console.log(this.game_file);
    }
  }

  //addgame

  uploadeGame(){
    this.icon='fa fa-spinner fa-spin';

    //create post form
    var data= new FormData();
    data.append('game_name',this.game_name);
    data.append('game_name_ar',this.game_name_ar);
    data.append('game_name_pr',this.game_name_pr);
    data.append('game_desc',this.game_desc);
    data.append('game_desc_ar',this.game_desc_ar);
    data.append('game_desc_pr',this.game_desc_pr);
    data.append('game_thumb',this.thumb);
    data.append('game_thumb1',this.thumb1);
    data.append('game_thumb2',this.thumb2);
    data.append('game_poster',this.poster);
    data.append('game_file',this.game_file);
    data.append('user_id',this.user_id);
    data.append('game_cat',this.game_cat);
    data.append('game_type',this.game_type);
    data.append('game_dev',this.game_dev);
    if(this.game_countries!=undefined){
      data.append('game_countries',this.game_countries);
    }
    if(this.package_name!=undefined){
      data.append('package_name',this.package_name);
    }

    if(this.has_leader){
      data.append('has_leader','1');
    }
    else {
      data.append('has_leader','0');

    }

    data.append('game_tags',this.game_tags);

    data.append('game_age',this.game_age);


    this.games.addGame(data).subscribe(
      next=>{console.log(next)},
      error=>{console.log(error)},
      ()=>{
        this.icon='glyphicon glyphicon-ok';

      }
    )

  }
  uploadeIcon(fa){
    this.icon=fa;
  }
  hasleader($ev){
    if($ev.target.checked){
      this.has_leader=true;
    }
    else {
      this.has_leader=false;
    }
  }


}



//get the user data frpm local stoage







// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/addgame/addgame.component.ts